import Chat from "./Chat";
import React, {useState , useEffect} from 'react';
import database from "./firebase.js";

function Chats() {
    const [people, setPeople] = useState([]);
    useEffect(() => {
        database.collection('people').onSnapshot(snapshot => (
            setPeople(snapshot.docs.map(doc => doc.data()))
        ))
        //this will run once when component loads and never again []
    }, [])
    return (
        <div className="Chats">
            {people.map((person) =>
                <Chat 
                name={person.name}
                message={person.message}
                timestamp={person.timestamp}
                profilePic={person.url}
                ></Chat>
            )}
        </div>
    )
}

export default Chats
